module.exports = __webpack_public_path__ + "img/decision.29e08470.svg";